import { render, staticRenderFns } from "./ListOfOCRReadFilesDialog.vue?vue&type=template&id=35ce5370&scoped=true&"
import script from "./ListOfOCRReadFilesDialog.vue?vue&type=script&lang=js&"
export * from "./ListOfOCRReadFilesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ce5370",
  null
  
)

export default component.exports